import {all} from 'redux-saga/effects';
import {saga as cryptoFragmentsSaga} from './crypto-fragments';

export default function* e2eeSaga() {
  yield all([
    cryptoFragmentsSaga(),
  ]);
}
